<template>
  <div class="progress-bar">
    <div :style="style" class="container flex">
      <span class="mr-20"> {{ Math.round((progress / max) * 100) }}%</span>
    </div>
  </div>
</template>

<script>
import "./progressBar.scss";
export default {
  name: "progress-bar",
  props: {
    max: {
      type: Number,
      default: 100
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style: {}
    };
  },
  created() {
    this.style = { width: (this.progress / this.max) * 100 + "%" };
  },
  computed: {},
  watch: {
    progress() {
      this.style = {
        ...this.style,
        width: (this.progress / this.max) * 100 + "%"
      };
    }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// progressBar.vue?289cc07e